export enum NotificationTransport {
  Push = 'push',
  PushCall = 'push_call',
  WebSocket = 'websocket',
  Sms = 'sms',
  Email = 'email',
}

export enum NotificationSendingTransportCondition {
  Always = 'always',
  IfNotSentYetByOtherTransports = 'ifNotSentYetByOtherTransports',
}

export interface INotificationSendingTransportConfig {
  transport: NotificationTransport;
  condition: NotificationSendingTransportCondition;
}

export type NotificationTransportsSequence = INotificationSendingTransportConfig[];
